/**
  * Add basic tab functionality with material design-like mobile focusing for nav buttons on mobile.
  */
const init = () => {
  const tabNav = document.querySelectorAll('.tabbed-details__nav');
  tabNav.forEach((tNav) => {
    tNav.addEventListener('click', e => {
      if(e.target.type === 'submit') {
        const tabs = document.querySelectorAll('.tabbed-details__nav button');
        const tab = e.target;
        const tabContents = document.querySelectorAll('.tabbed-details__tab-content');

        if (tab.classList.contains('active')) {
          tabContents.forEach(t => t.classList.add('d-none'));
          tabs.forEach(tb => tb.classList.remove('active'));
        } else {
          tabs.forEach(tb => {
            tabContents.forEach(t => t.classList.add('d-none'));
            tabs.forEach(tb => tb.classList.remove('active'));
            tab.classList.add('active');

            const centerOffset = Math.max(tab.offsetLeft + tab.offsetWidth / 2 - tab.offsetParent.offsetWidth / 2, 0);
            tNav.scrollTo({
              left: centerOffset,
              behavior: 'smooth'
            });

            document.getElementById(tab.dataset.target)?.classList.remove('d-none');
          });
        }

      }
    });
  });
}

export default {
  init
}
